import { FastField } from 'formik';
import { KoobInputSelect } from '@koob/ui';
import { ErrorMessageWrapper, FormField, FormLabel } from 'ui/forms';

const FastCurrencyField = ({ currenciesOptions, label, name, ...props }) => (
  <FormField>
    <FormLabel>{label}</FormLabel>
    <FastField name={name}>
      {({ field, meta, form }) => {
        const hasError = Boolean(meta.touched) && Boolean(meta.error);
        return (
          <>
            <KoobInputSelect
              {...props}
              value={field.value}
              error={hasError}
              onValueChange={(value) => {
                form.setFieldValue(name, value);
              }}
              options={currenciesOptions}
            />
            {hasError && (
              <ErrorMessageWrapper>{meta.error}</ErrorMessageWrapper>
            )}
          </>
        );
      }}
    </FastField>
  </FormField>
);

export default FastCurrencyField;
